import { Injectable } from '@angular/core'
import { RestService } from '../../core/rest.service'
import { ElementRow } from './treelist.model';

@Injectable()
export class TreelistRest {
    constructor(
        private http: RestService
    ){}

    public getFirstLevelElements(apiPath: string) {
        return this.http.get<ElementRow[]>(`${apiPath}/treelist`);
    }

    public getElementChildren(apiPath: string, elementId: any) {
        return this.http.get<ElementRow[]>(`${apiPath}/treelist/${elementId}`);
    }
}